import { render, staticRenderFns } from "./EditableColumnOfFields.vue?vue&type=template&id=65ed192c&scoped=true&"
import script from "./EditableColumnOfFields.vue?vue&type=script&lang=ts&"
export * from "./EditableColumnOfFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed192c",
  null
  
)

export default component.exports